module.exports = __webpack_public_path__ + "img/bg_foimal02.8193f731.jpg";